import React from 'react';
import PropTypes from 'prop-types';
import Chip from '@prism/chip';
import classNames from 'classnames';

class PrismChip extends React.PureComponent {
    static propTypes = {
        type: PropTypes.string,
        className: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.object,
            PropTypes.array
        ]),
        selected: PropTypes.bool,
        onClick: PropTypes.func,
        disabled: PropTypes.bool
    };

    static defaultProps = {
        type: 'select',
        selected: false,
        disabled: false
    };

    render() {
        const {
            type,
            children,
            selected,
            onClick,
            className,
            disabled
        } = this.props;

        const containerClassName = classNames(
            'prism-sandbox',
            'prism-chip',
            { 'prism-chip_disabled': disabled },
            className
        );

        return (
            <span className={containerClassName}>
                <Chip
                    type={type}
                    selected={selected}
                    onClick={onClick}
                >
                    {children}
                </Chip>
            </span>
        );
    }
}

export default PrismChip;
